import { CONFIG } from "./utils/config";

require("./api/hostFetcher");
require("./utils/session");

import Vue from "vue";
import Vuex from "vuex";
import App from "./App";
import store from "./store";
// import BootstrapVue from "bootstrap-vue";
import VueChatScroll from "vue-chat-scroll";
import { i18n } from "./language";
import Antd from "ant-design-vue";
import VeeValidate from "vee-validate";
import messagesTR from "./language/validationMessagesTR";
import messagesEN from "./language/validationMessagesEN";
import messagesRU from "./language/validationMessagesRU";
import messagesDE from "./language/validationMessagesDE";
import messagesFR from "./language/validationMessagesFR";
import messagesES from "./language/validationMessagesES";
import messagesAR from "./language/validationMessagesAR";
import messagesIT from "./language/validationMessagesIT";
import vuescroll from "vuescroll";

// import "bootstrap/dist/css/bootstrap.css";
// import "bootstrap-vue/dist/bootstrap-vue.css";
import "ant-design-vue/dist/antd.css";
import "./utils/parentWindowConnection";
import { installHeaderDrag } from "./utils/headerDrag";
installHeaderDrag();
import VueMaterial from "vue-material";
import "vue-material/dist/vue-material.min.css";
import "vue-material/dist/theme/default.css";

import { onAppLoaded } from "./utils/utils";
import { allThemeColors, defaultPreferredThemeColor } from "./store/modules/setting";
import { getPersistenceData, removePersistenceData, setPersistenceData } from "./utils/persistenceStorage";
import VueTheMask from "vue-the-mask";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { ObserveVisibility } from "vue-observe-visibility";
import AkinonScrapperApiClient from "./utils/AkinonScrapperApiClient";
import VueAudioVisual from "vue2-audio-visual";



Vue.directive("observe-visibility", ObserveVisibility);
Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.use(VueTheMask);
Vue.use(Vuex);
Vue.use(VueAudioVisual);
// Vue.use(BootstrapVue);
Vue.use(VueChatScroll);
Vue.use(Antd);
Vue.use(VueMaterial);
Vue.use(VeeValidate, {
    locale: "tr",
    fieldsBagName: "veeFields",
    dictionary: {
        tr: { messages: messagesTR.messages },
        en: { messages: messagesEN.messages },
        ru: { messages: messagesRU.messages },
        de: { messages: messagesDE.messages },
        fr: { messages: messagesFR.messages },
        es: { messages: messagesES.messages },
        ar: { messages: messagesAR.messages },
        it: { messages: messagesIT.messages },
    },
});
Vue.use(vuescroll);

Vue.config.productionTip = false;
Object.defineProperty(Vue.prototype, "$_", { value: _ });


Vue.directive("truncate", {
    bind: function (el, binding) {
        el.innerText = `${el.innerText.slice(0, binding.value)}... ${el.innerText.slice(binding.value / -2)}`;
    },
});

new Vue({
    el: "#app",
    i18n,
    store,
    render: (h) => h(App),
});

onAppLoaded().then(() => {
    const className = getPersistenceData("lastPreferredThemeColor") || defaultPreferredThemeColor;
    const app = document.getElementById("app");

    allThemeColors.forEach((color) => {
        if (app) app.classList.remove(color);
    });
    if (app) app.classList.add(className);

    const akinonScrapperApiClient = AkinonScrapperApiClient.create();
});
const sentryDisabledOrigins = ["sdu.visitor.supsis.live"];
const isEnabledSite = () => {
    const enabledSites = [
        "visitor.supsis.live",
        "betavisitor.supsis.live",
        "betnano.visitor.supsis.live",
        "truvabet.visitor.supsis.live",
    ];
    const randomSelector = (Math.random() * 4) % 3 === 0;
    return randomSelector && enabledSites.includes(window.location.hostname);
};
if (isEnabledSite()) {
    Sentry.init({
        Vue,
        dsn: "https://1373d5bbc84d4c2ba0d0b855671b24f9@o1039697.ingest.sentry.io/6110282",
        integrations: [
            new Integrations.BrowserTracing({
                tracingOrigins: [
                    "localhost",
                    "*.supsis.live",
                    "api.supsis.live",
                    "apicdn.supsis.live",
                    "beta-api.supsis.live",
                    "socket.supsis.live",
                    "beta-socket.supsis.live",
                    "tablet-api-local.supsis.live/",
                ],
            }),
        ],
        // Set tracesSampleRate to 1.0 to capture 100%
        // of transactions for performance monitoring.
        // We recommend adjusting this value in production
        tracesSampleRate: 0.01,
        sampleRate: 0.01,
        environment: process.env.NODE_ENV,
        enabled: isEnabledSite() && !sentryDisabledOrigins.includes(window.location.hostname),
        release: require("../package.json").version,
        ignoreTransactions: false,
        beforeSend(event) {
            // do not send if error is "Axios Error"
            const errors = _.get(event, "exception.values", []) || [];
            const isAxiosIncludes = errors.some((error) => {
                const isAxios = (error.value || "").toLowerCase().includes("axios");
                const isNetwork = (error.value || "").toLowerCase().includes("network");
                const isTimeout = (error.value || "").toLowerCase().includes("timeout");
                return !isTimeout && (isNetwork || isAxios);
            });
            if (isAxiosIncludes) {
                return null;
            }
            return event;
        },
    });
}

window.Sentry = Sentry;



// WEBPACK FOOTER //
// ./src/main.js